import React from "react";
import { Callout, BoxTone } from "@/components/ms";

/**
 * The in-flow alert box (docs/design/newia-web/Alerts.html). This is a thin
 * mapping of the legacy variant names onto the kit's `Callout` so the ~30
 * TaxForm call sites keep working.
 */

type AlertVariant = "warning" | "info" | "success" | "error";

interface AlertProps {
  variant?: AlertVariant;
  title?: string;
  message?: string;
  children?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
  dismissible?: boolean;
  onDismiss?: () => void;
  className?: string;
}

const VARIANT_TONE: Record<AlertVariant, BoxTone> = {
  info: "default",
  success: "default",
  warning: "caution",
  error: "problem",
};

export const Alert: React.FC<AlertProps> = ({
  variant = "info",
  title,
  message,
  children,
  action,
  className,
}) => (
  <Callout
    tone={VARIANT_TONE[variant]}
    title={title}
    go={action ? { label: action.label, onClick: action.onClick } : undefined}
    className={className}
  >
    {message}
    {children}
  </Callout>
);

// Legacy component for backward compatibility
export const AlertWithComponent = ({ children }) => (
  <Alert variant="warning">{children}</Alert>
);

// Legacy component for backward compatibility
export const SuccessAlert = ({ text }) => <Alert variant="success" message={text} />;
